export function withoutCollectionMetadata<T extends object>(value: T): T {
  return Object.fromEntries(Object.entries(value).filter(([key]) => !key.startsWith('$'))) as T
}

export function migrateLegacyDeletedField(oldDocument: Record<string, unknown>) {
  const { deleted, ...document } = oldDocument
  return { ...document, isDeleted: Boolean(deleted) }
}

export function migrateLabelColor(oldDocument: Record<string, unknown>) {
  return { ...oldDocument, color: oldDocument.color ?? 'default' }
}

export function migrateLabelKind(oldDocument: Record<string, unknown>) {
  return { ...oldDocument, kind: oldDocument.kind ?? 'note' }
}

export function migrateMealLabels(oldDocument: Record<string, unknown>) {
  return { ...oldDocument, labelIds: oldDocument.labelIds ?? [] }
}

export function migrateNoteSortOrder(oldDocument: Record<string, unknown>) {
  const previousOrder = -Date.parse(String(oldDocument.updatedAt))
  return { ...oldDocument, sortOrder: oldDocument.sortOrder ?? (Number.isFinite(previousOrder) ? previousOrder : 0) }
}
